import {
  BACK_TO_LOGIN,
  CHECK_YOUR_INBOX,
  DESCRIPTION,
  DOUBLE_CHECK,
  EMAIL_DIDNT_ARRIVE,
  EMAIL_RESENT,
  ERROR,
  RESEND_IN,
  RESEND_RESET_LINK
} from './constants'

export const getDoubleCheck = (t) => {
  return t('m_double_check') || DOUBLE_CHECK
}

export const getTitle = (t) => {
  return t(`m_email_didn't_arrive`) || EMAIL_DIDNT_ARRIVE
}

export const getFAQ = (t, translation, fallback) => {
  return t(translation) || fallback
}

export const getError = (t) => {
  return t('e_error_try_again') || ERROR
}

export const getEmailResent = (t) => {
  return t('a_email_resent') || EMAIL_RESENT
}

export const getResendIn = (t) => {
  return t('a_resend_in_countdown') || RESEND_IN
}

export const getResendResetLink = (t) => {
  return t('a_resend_reset_link') || RESEND_RESET_LINK
}

export const getBackToLogIn = (t) => {
  return t('a_back_to_log_in') || BACK_TO_LOGIN
}

export const getPageTitle = (t) => {
  return t('d_check_inbox') || CHECK_YOUR_INBOX
}

export const getDescription = (t) => {
  return t('m_if_account_reset_link') || DESCRIPTION
}

export const isButtonDisabled = (emailSent, emailSuccess, recaptchaToken) => {
  return emailSent || emailSuccess || !recaptchaToken
}
